import * as React from 'react';
import Modal from 'react-modal';
import { IconButton } from './ui-kit/IconButton';

import styles from './Modal.module.scss';
import CloseIcon from '@lmt/unicorn-shared/app/icons/close.svg?react';

const { overlay, content } = Modal.defaultStyles;

if (overlay) {
  overlay.backgroundColor = 'rgba(#1F2532, 0.75)';
  overlay.zIndex = 1000;
  overlay.overflow = 'auto';
  overlay.textAlign = 'center';
}

Modal.defaultStyles = { overlay, content };

const node = document.getElementById('root');
if (node) {
  Modal.setAppElement(node);
}

interface ModalOwnProps {
  contentLabel?: string;
  onRequestClose?: () => void;
}

type ModalProps = ModalOwnProps & Modal.Props;

export const StyledModal: React.FC<React.PropsWithChildren<ModalProps>> = (
  props,
) => {
  const { onRequestClose, contentLabel } = props;

  return (
    <Modal className={styles.popup} {...props}>
      <div className={styles.window}>
        <div className={styles.header}>
          <div className={styles.headerStart}>
            <div className={styles.formTitle}>{contentLabel}</div>
          </div>
          <div className={styles.headerEnd}>
            <div className={styles.formButtons}>
              <IconButton
                color="light"
                className={styles.formButton}
                onClick={onRequestClose}
                iconComponent={<CloseIcon className={styles.formButtonIcon} />}
                testId={'modal-closeIcon'}
              />
            </div>
          </div>
        </div>
        <div className={styles.children}>{props.children}</div>
      </div>
    </Modal>
  );
};
